import { Component, Input, OnInit } from "@angular/core";
import { AuthService } from "../auth.service";

import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { ToastrManager } from "ng6-toastr-notifications";

@Component({
  selector: "app-new-password-challange",
  templateUrl: "./new-password-challange.component.html",
  styleUrls: ["./new-password-challange.component.css"]
})
export class NewPasswordChallangeComponent implements OnInit {
  public pswd;
  constructor(
    private auth: AuthService,
    public activeModal: NgbActiveModal,
    private router: Router,
    private toastr: ToastrManager
  ) {}

  ngOnInit() {
    this.pswd = {
      userName: "",
      password: "",
      newPassword: "",
      confirmPassword: ""
    };
  }
  newPasswordChallange(req) {
    console.log(req);
    req["userName"] = localStorage.getItem("newUser");
    req["clientId"] = localStorage.getItem("clientId");
    req["poolId"] = localStorage.getItem("poolId");
    console.log(req);
    this.auth.userLogin(req).subscribe(data => {
      console.log(data);
      localStorage.removeItem("newUser");
      if (data.Status == "Success") {
        // window.alert("Password changed successfully");
        this.toastr.successToastr("Password Changed Successfully","Success!");
      } else {
        // window.alert("Password change Failed");
        this.toastr.errorToastr("Password Change Failed","oops!")
      }
      this.activeModal.close();
      this.router.navigate(["/login"]);
    });
  }
}
